const resource = '/v1/comments';

export default $axios => ({
  findByProposalId(config) {
    return $axios.get(`${resource}`, config);
  },

  create(payload) {
    return $axios.post(`${resource}`, payload);
  },

  delete(id) {
    return $axios.delete(`${resource}/${id}`);
  }
});
